import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" OK ")

import { useLoadingDialogStore } from '@/stores/useLoadingDialogStore';
import { useSimpleDialogStore } from '@/stores/useSimpleDialogStore';

import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { computed, defineAsyncComponent, onMounted, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

// Stores
const loadingDialogStore = useLoadingDialogStore();
const { active } = storeToRefs(loadingDialogStore);
const simpleDialogStore = useSimpleDialogStore();
const {
  showSimpleDialog,
  simpleDialogMessage,
} = storeToRefs(simpleDialogStore);

// Computed
const layoutComponent = computed(() => route.meta.layout ? defineAsyncComponent(() => import(`@/layouts/${route.meta.layout}.vue`)) : '');

onMounted(() => {
  handleWindowResize();
  window.addEventListener('resize', handleWindowResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleWindowResize);
});

function handleWindowResize() {
  const vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

return (_ctx: any,_cache: any) => {
  const _component_va_progress_circle = _resolveComponent("va-progress-circle")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layoutComponent)), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-300",
            "enter-from-class": "opacity-0 transform -translate-y-5",
            "enter-to-class": "opacity-100 transform translate-y-0",
            "leave-active-class": "transition ease-in duration-300",
            "leave-from-class": "opacity-100 transform translate-y-0",
            "leave-to-class": "opacity-0 transform -translate-y-5"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: "routerViewSlot" }))
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_va_modal, {
            modelValue: _unref(active),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(active) ? (active).value = $event : null)),
            "no-dismiss": ""
          }, {
            content: _withCtx(() => [
              _createVNode(_component_va_progress_circle, { indeterminate: "" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_modal, {
            modelValue: _unref(showSimpleDialog),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showSimpleDialog) ? (showSimpleDialog).value = $event : null)),
            class: "simple-dialog"
          }, {
            content: _withCtx(({ ok }) => [
              _createVNode(_component_va_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(simpleDialogMessage)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_va_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_va_button, { onClick: ok }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})